if (!customElements.get('mova-duffle')) {
  customElements.define('mova-duffle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.busy = false;
      this.querySelectorAll('.md__product-details summary').forEach(summary => {
        summary.addEventListener('click', event => event.stopPropagation());
      });
      this.styleKey = this.dataset.initial;
      const swatchMap = new Map();
      let swatchText = '';
      try { swatchText = JSON.parse(this.dataset.swatchMap || '""'); } catch (_) {}
      for (const line of String(swatchText).split('\n')) {
        const separator = line.indexOf(':');
        if (separator < 0) continue;
        const colourName = line.slice(0, separator).trim().toLowerCase();
        const colourValue = line.slice(separator + 1).trim();
        if (/^#[0-9a-f]{3,8}$/i.test(colourValue)) swatchMap.set(colourName, colourValue);
      }
      this.format = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:this.dataset.currency}).format(cents / 100);
      this.querySelectorAll('[data-bag-variant]').forEach(select => {
        const swatches = select.closest('[data-bag]').querySelector('[data-swatches]');
        [...select.options].forEach(option => {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'md__swatch';
          button.title = option.textContent; button.setAttribute('aria-label',option.textContent);
          button.disabled = option.disabled;
          button.dataset.variant = option.value;
          const colour = option.textContent.toLowerCase();
          let paint = '#777';
          if (colour.includes('beige')) paint='#e3d3bb';
          else if (colour.includes('pink')) paint='#dfb0a4';
          else if (colour.includes('olive')) paint='#596247';
          else if (colour.includes('brown')) paint='linear-gradient(135deg,#252525 50%,#a26b45 50%)';
          else if (colour.includes('black')) paint='#252525';
          paint = swatchMap.get(colour.trim()) || paint;
          button.style.setProperty('--swatch',paint);
          button.addEventListener('click',()=>{select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));});
          swatches.append(button);
        });
      });
      this.dataset.enhanced='true';
      this.addEventListener('change',event=>{
        const styleChanged=event.target.matches('.md__styles input[type=radio]');
        if (styleChanged) {
          const previous = this.currentOption();
          this.styleKey=event.target.value;
          const select=this.currentSelect();
          const matching=[...select.options].find(o=>o.textContent===previous?.textContent&&!o.disabled);
          if(matching) select.value=matching.value;
        }
        this.sync({updateMedia:styleChanged||event.target.matches('[data-bag-variant]')});
      });
      this.querySelectorAll('[data-thumb]').forEach(button=>button.addEventListener('click',()=>this.selectMedia(button.dataset.thumb,button.dataset.thumbStyle)));
      const thumbs=this.querySelector('.md__thumbs');
      this.querySelectorAll('[data-thumb-step]').forEach(button=>button.addEventListener('click',()=>{
        thumbs.scrollBy({left:Number(button.dataset.thumbStep)*thumbs.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }));
      thumbs.addEventListener('scroll',()=>this.updateThumbSteps(),{passive:true});
      new ResizeObserver(()=>this.updateThumbSteps()).observe(thumbs);
      const rail=this.querySelector('.md__slides');
      const updatePosition=()=>{const position=this.querySelector('[data-gallery-position]');if(position)position.textContent=(Math.round(rail.scrollLeft/rail.clientWidth)+1)+' / '+rail.children.length;};
      rail.addEventListener('scroll',updatePosition,{passive:true});
      new ResizeObserver(updatePosition).observe(rail);
      updatePosition();
      rail.addEventListener('scrollend',()=>{
        const slide=rail.children[Math.round(rail.scrollLeft/rail.clientWidth)];
        if(slide) this.selectMedia(slide.dataset.media,slide.dataset.mediaStyle);
      });
      this.querySelectorAll('.md__form').forEach(form=>form.addEventListener('submit',event=>{event.preventDefault();this.add(this.items());}));
      this.querySelectorAll('[data-add-package]').forEach(button=>button.addEventListener('click',()=>this.add(this.items(button.closest('[data-package]')))));
      this.sync({updateMedia:true});
      this.updateThumbSteps();
    }
    currentSelect() {return this.querySelector('[data-bag="'+this.styleKey+'"] [data-bag-variant]');}
    currentOption() {return this.currentSelect()?.selectedOptions[0];}
    showMedia(gallery,id) {
      const slide=[...gallery.querySelectorAll('[data-media]')].find(el=>el.dataset.media===id&&el.dataset.mediaStyle===this.styleKey);
      const rail=gallery.querySelector('.md__slides');
      if(slide) rail.scrollTo({left:slide.offsetLeft-rail.firstElementChild.offsetLeft,behavior:'auto'});
      gallery.querySelectorAll('video').forEach(video=>video.pause());
      const thumbs=gallery.querySelector('.md__thumbs');
      gallery.querySelectorAll('[data-thumb]').forEach(button=>{
        const active=button.dataset.thumb===id&&button.dataset.thumbStyle===this.styleKey;
        if(active) {
          button.setAttribute('aria-current','true');
          const left=button.getBoundingClientRect().left-thumbs.getBoundingClientRect().left+thumbs.scrollLeft;
          if(left<thumbs.scrollLeft||left+button.offsetWidth>thumbs.scrollLeft+thumbs.clientWidth)thumbs.scrollTo({left:Math.max(0,left-thumbs.clientWidth/2+button.offsetWidth/2),behavior:'auto'});
        } else button.removeAttribute('aria-current');
      });
    }
    selectMedia(id,style) {
      if(this.busy) return;
      const previous=this.currentOption();
      this.styleKey=style;
      const radio=this.querySelector('.md__styles input[value="'+style+'"]');
      if(radio)radio.checked=true;
      const select=this.currentSelect();
      const exact=[...select.options].find(o=>o.dataset.media===id&&!o.disabled);
      const matching=[...select.options].find(o=>o.textContent===previous?.textContent&&!o.disabled);
      if(exact||matching)select.value=(exact||matching).value;
      this.sync();
      this.showMedia(this.querySelector('[data-gallery]'),id);
    }
    updateThumbSteps() {
      const thumbs=this.querySelector('.md__thumbs');
      this.querySelector('[data-thumb-step="-1"]').disabled=thumbs.scrollLeft<2;
      this.querySelector('[data-thumb-step="1"]').disabled=thumbs.scrollLeft+thumbs.clientWidth>=thumbs.scrollWidth-2;
    }
    sync({updateMedia=false}={}) {
      const option=this.currentOption();
      const galleryPrice=this.querySelector('[data-gallery-price]');
      if(galleryPrice&&option)galleryPrice.textContent=this.format(Number(option.dataset.price));
      const paymentBlock=this.querySelector('[data-payment-block]')||document.querySelector('[data-mova-payment]');
      const activeButton=this.querySelector('[data-bag="'+this.styleKey+'"] .md__atc');
      if(paymentBlock&&activeButton){
        if(activeButton.nextElementSibling!==paymentBlock)activeButton.after(paymentBlock);
        paymentBlock.querySelectorAll('square-placement,afterpay-placement').forEach(placement=>{
          placement.setAttribute('data-amount',(Number(option?.dataset.price||0)/100).toFixed(2));
          placement.setAttribute('data-currency',this.dataset.currency);
        });
      }
      this.querySelectorAll('[data-instalment]').forEach(e=>e.textContent=this.format(Number(option?.dataset.price||0)/4));
      this.querySelectorAll("select").forEach(select=>select.tabIndex=0);
      this.querySelectorAll('[data-bag],[data-rating],[data-description]').forEach(el=>el.hidden=(el.dataset.bag||el.dataset.rating||el.dataset.description)!==this.styleKey);
      this.querySelectorAll('[data-bag]').forEach(panel=>{
        const selection=panel.querySelector('select').selectedOptions[0];
        const available=selection?.dataset.available==='true';
        panel.querySelector('[data-main-price]').textContent=this.format(Number(selection?.dataset.price||0));
        panel.querySelector('[data-button-label]').textContent=available?this.dataset.add:this.dataset.unavailable;
        panel.querySelector('[data-colour-name]').textContent=' · '+(selection?.textContent||'');
        const style=panel.dataset.bag;
        const name=this.querySelector('.md__styles input[value="'+style+'"]').closest('label').querySelector('strong').textContent;
        const selectionLabel=panel.querySelector('.md__selection');
        if(selectionLabel) selectionLabel.textContent=name+' · '+(style==='classic'?this.querySelector('.md__styles input[value="classic"]').closest('label').querySelector('small').textContent:this.querySelector('.md__styles input[value="roller"]').closest('label').querySelector('small').textContent)+' · '+(selection?.textContent||'');
        panel.querySelector('[type=submit]').disabled=this.busy||!available;
        panel.querySelectorAll('[data-variant]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.variant===selection?.value)));
      });
      if(updateMedia&&option?.dataset.media) this.showMedia(this.querySelector('[data-gallery]'),option.dataset.media);
      this.querySelectorAll('[data-package]').forEach(card=>{
        const bagOption=card.querySelector('[data-package-bag]')?.selectedOptions[0]||option;
        const extras=[...card.querySelectorAll('[data-extra]')];
        const available=bagOption?.dataset.available==='true'&&extras.length>0&&extras.every(s=>s.selectedOptions[0]?.dataset.available==='true');
        const total=Number(bagOption?.dataset.price||0)+extras.reduce((sum,s)=>sum+Number(s.selectedOptions[0]?.dataset.price||0),0);
        const style=this.querySelector('input[value="'+this.styleKey+'"]')?.closest('label').querySelector('strong').textContent||'';
        const bagLabel=card.querySelector('[data-selected-bag]');if(bagLabel)bagLabel.textContent=style+' · '+(option?.textContent||'');
        const bagImage=card.querySelector('.md__setbag img');const bagSrc=bagOption.dataset.image||this.querySelector('[data-media-style="'+this.styleKey+'"][data-media="'+bagOption.dataset.media+'"] img')?.src;if(bagSrc&&bagImage){bagImage.removeAttribute('srcset');bagImage.src=bagSrc;}
        card.querySelector('[data-total]').textContent=this.format(total);
        card.querySelector('[data-add-package]').disabled=this.busy||!available;
        extras.forEach(select=>{const src=select.selectedOptions[0]?.dataset.image;const image=select.closest('.md__accessory').querySelector('img');if(src&&image){image.removeAttribute("srcset");image.src=src;}});
      });
      this.querySelectorAll('select,input,[data-variant]').forEach(el=>{
        if(this.busy){el.dataset.wasDisabled=String(el.disabled);el.disabled=true;}
        else if(el.dataset.wasDisabled!==undefined){el.disabled=el.dataset.wasDisabled==='true';delete el.dataset.wasDisabled;}
      });
    }
    items(card) {
      const selection=card?.querySelector('[data-package-bag]')?.selectedOptions[0]||this.currentOption();
      if(!selection||selection.dataset.available!=='true') return [];
      const items=[{id:Number(selection.value),quantity:1}];
      if(card) for(const select of card.querySelectorAll('[data-extra]')) {
        const option=select.selectedOptions[0];
        if(!option||option.dataset.available!=='true') return [];
        items.push({id:Number(option.value),quantity:1});
      }
      return items;
    }
    async add(items) {
      if(this.busy||!items.length) return;
      this.busy=true;this.sync();
      const status=this.querySelector('[data-status]');status.textContent=this.dataset.adding;
      try {
        const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(error.description||this.dataset.error);}
        location.assign(this.dataset.cartUrl);
      } catch(error) {
        status.textContent=error.message||this.dataset.error;
        this.busy=false;this.sync();
      }
    }
  });
}

